const OpenRoute = ({ children }) => {
  return children;
};

export default OpenRoute;
